import { EdgeStateErrorState } from "../../graphql/graphql";
import { Status } from "../StatusTag/utils";

/**
 * Maps the EdgeStateErrorState to a valid status string.
 */
export const mapEdgeStateErrorStateToStatus = (
  errorState: EdgeStateErrorState,
): Status => {
  switch (errorState) {
    case EdgeStateErrorState.Unrecognized:
      return "error";
    case EdgeStateErrorState.None:
      return "ok";
    case EdgeStateErrorState.Handling:
      return "warning";
    case EdgeStateErrorState.Error:
      return "error";
  }
};
